import { render } from "./ProfileTemplatesList.vue?vue&type=template&id=6c48efea"
import script from "./ProfileTemplatesList.vue?vue&type=script&lang=js"
export * from "./ProfileTemplatesList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__